var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreliminaryEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756778546993,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5291,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.7 102.4H205.8c-44.5 0-80.6 36.2-80.6 80.6v230c0 44.5 36.2 80.6 80.6 80.6h229.9c44.5 0 80.6-36.2 80.6-80.6V183c0.1-44.4-36.1-80.6-80.6-80.6z m0.7 310.6c0 0.4-0.3 0.6-0.6 0.6h-230c-0.4 0-0.6-0.3-0.6-0.6V183c0-0.4 0.3-0.6 0.6-0.6h229.9c0.4 0 0.6 0.3 0.6 0.6v230zM858.3 134.1H622.4c-22.1 0-40 17.9-40 40s17.9 40 40 40h235.9c22.1 0 40-17.9 40-40s-17.9-40-40-40zM858.3 260.7H622.4c-22.1 0-40 17.9-40 40s17.9 40 40 40h235.9c22.1 0 40-17.9 40-40s-17.9-40-40-40zM858.3 387.3H622.4c-22.1 0-40 17.9-40 40s17.9 40 40 40h235.9c22.1 0 40-17.9 40-40s-17.9-40-40-40zM435.7 538H205.8c-44.5 0-80.6 36.2-80.6 80.6v229.9c0 44.5 36.2 80.6 80.6 80.6h229.9c44.5 0 80.6-36.2 80.6-80.6V618.7c0.1-44.5-36.1-80.7-80.6-80.7z m0.7 310.6c0 0.4-0.3 0.6-0.6 0.6h-230c-0.4 0-0.6-0.3-0.6-0.6V618.7c0-0.4 0.3-0.6 0.6-0.6h229.9c0.4 0 0.6 0.3 0.6 0.6v229.9zM858.3 569.8H622.4c-22.1 0-40 17.9-40 40s17.9 40 40 40h235.9c22.1 0 40-17.9 40-40s-17.9-40-40-40zM858.3 696.4H622.4c-22.1 0-40 17.9-40 40s17.9 40 40 40h235.9c22.1 0 40-17.9 40-40s-17.9-40-40-40zM858.3 822.9H622.4c-22.1 0-40 17.9-40 40s17.9 40 40 40h235.9c22.1 0 40-17.9 40-40s-17.9-40-40-40z",
    "p-id": 5292,
    fill: "#0050C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreliminaryEvaluation);
export default __webpack_public_path__ + "static/media/preliminary-evaluation.8c89b10a3a172b22ccdf643d1392f54b.svg";
export { ForwardRef as ReactComponent };